import React from "react";
import AboutMissionImage from "../../assets/images/about-us/mission.png";
import AboutVisionImage from "../../assets/images/about-us/vision.png";
import AboutValueImage from "../../assets/images/about-us/values.png";

const Services = () => {
  const values = [
    {
      title: "Integrity:",
      desc: "We operate with honesty, transparency, and accountability—building lasting trust with hospitality businesses around the world.",
      emoji: "🤝",
      bgColor: "tw-bg-rose-50",
      textColor: "tw-text-rose-600"
    },
    {
      title: "Excellence:",
      desc: "We are committed to delivering exceptional experiences through high-quality technology, accurate data, and reliable support that our clients can count on.",
      emoji: "🏆",
      bgColor: "tw-bg-amber-50",
      textColor: "tw-text-amber-600"
    },
    {
      title: "Innovation with Purpose:",
      desc: "We leverage AI and emerging technologies to solve real challenges in the hospitality industry, constantly evolving to deliver smarter, more impactful solutions.",
      emoji: "⚡",
      bgColor: "tw-bg-violet-50",
      textColor: "tw-text-violet-600"
    },
    {
      title: "Guest-Centric Thinking:",
      desc: "Our platform is designed with your guests in mind—empowering you to personalize engagement, automate interactions, and exceed expectations at every touchpoint.",
      emoji: "🏨",
      bgColor: "tw-bg-emerald-50",
      textColor: "tw-text-emerald-600"
    },
    {
      title: "Continuous Growth:",
      desc: "We believe in progress—for our clients, our platform, and our team. We constantly learn, adapt, and improve to stay ahead of industry shifts and hospitality trends.",
      emoji: "📈",
      bgColor: "tw-bg-sky-50",
      textColor: "tw-text-sky-600"
    }
  ];

  return (
    <section className="tw-py-20 lg:tw-py-28 tw-bg-white">
      <div className="tw-max-w-7xl tw-mx-auto tw-px-4 sm:tw-px-6 lg:tw-px-8">
        
        {/* Header */}
        <div className="tw-text-center tw-max-w-3xl tw-mx-auto tw-mb-16">
          <h2 className="tw-text-2xl sm:tw-text-3xl lg:tw-text-4xl tw-font-extrabold tw-text-slate-900 tw-leading-tight">
            Unlock AI-Driven Solutions to Accelerate Your Hospitality Business Growth <br /> and Stay Ahead of the Competition!
          </h2>
        </div>

        {/* Vision & Mission Cards */}
        <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-8">
          
          {/* Vision */}
          <div className="tw-relative tw-overflow-hidden tw-bg-white tw-border tw-border-solid tw-border-slate-100 tw-rounded-3xl tw-p-8 sm:tw-p-10 tw-shadow-sm hover:tw-shadow-xl hover:tw-scale-[1.01] tw-transition-all tw-duration-300 tw-text-left">
            {/* Ghost watermark */}
            <div className="tw-absolute tw-bottom-[-12px] tw-right-[-12px] tw-w-28 tw-h-28 tw-opacity-[0.06] tw-pointer-events-none">
              <img src={AboutVisionImage} alt="" aria-hidden="true" className="tw-w-full tw-h-full tw-object-contain" />
            </div>
            <div
              className="tw-w-14 tw-h-14 tw-rounded-2xl tw-flex tw-items-center tw-justify-center tw-mb-4"
              style={{ backgroundColor: "#EEF2FF", border: "1.5px solid #C7D2FE" }}
            >
              <img
                src={AboutVisionImage}
                alt="Our Vision"
                className="tw-w-8 tw-h-8 tw-object-contain"
              />
            </div>
            <h3 className="tw-text-xl tw-font-bold tw-text-slate-800 tw-mb-4">Our Vision</h3>
            <p className="tw-text-sm tw-text-slate-500 tw-leading-relaxed tw-m-0">
              To become the leading AI-powered platform for the hospitality industry—enabling hotels worldwide to operate smarter, connect deeper, and grow faster by harnessing the full potential of data, automation, and guest-centric innovation.
            </p>
          </div>

          {/* Mission */}
          <div className="tw-relative tw-overflow-hidden tw-bg-white tw-border tw-border-solid tw-border-slate-100 tw-rounded-3xl tw-p-8 sm:tw-p-10 tw-shadow-sm hover:tw-shadow-xl hover:tw-scale-[1.01] tw-transition-all tw-duration-300 tw-text-left">
            {/* Ghost watermark */}
            <div className="tw-absolute tw-bottom-[-12px] tw-right-[-12px] tw-w-28 tw-h-28 tw-opacity-[0.06] tw-pointer-events-none">
              <img src={AboutMissionImage} alt="" aria-hidden="true" className="tw-w-full tw-h-full tw-object-contain" />
            </div>
            <div
              className="tw-w-14 tw-h-14 tw-rounded-2xl tw-flex tw-items-center tw-justify-center tw-mb-4"
              style={{ backgroundColor: "#EEF2FF", border: "1.5px solid #C7D2FE" }}
            >
              <img
                src={AboutMissionImage}
                alt="Our Mission"
                className="tw-w-8 tw-h-8 tw-object-contain"
              />
            </div>
            <h3 className="tw-text-xl tw-font-bold tw-text-slate-800 tw-mb-4">Our Mission</h3>
            <p className="tw-text-sm tw-text-slate-500 tw-leading-relaxed tw-m-0">
              To empower hospitality businesses with intelligent, AI-driven tools that simplify operations, enhance guest experiences, and drive sustainable growth. We aim to transform the way hotels and travel brands engage with prospects and guests—through automation, smart insights, and seamless communication.
            </p>
          </div>

        </div>

        {/* Core Values Section */}
        <div className="tw-bg-slate-50/50 tw-border tw-border-solid tw-border-slate-100 tw-rounded-3xl tw-p-8 sm:tw-p-10 tw-mt-12 tw-text-left">
          
          {/* Section title inside container */}
          <div className="tw-flex tw-items-center tw-gap-4 tw-mb-8">
            <div
              className="tw-w-12 tw-h-12 tw-rounded-2xl tw-flex tw-items-center tw-justify-center"
              style={{ backgroundColor: "#EEF2FF", border: "1.5px solid #C7D2FE" }}
            >
              <img
                src={AboutValueImage}
                alt="Our Core Values"
                className="tw-w-6 tw-h-6 tw-object-contain"
              />
            </div>
            <div>
              <h3 className="tw-text-lg tw-font-extrabold tw-text-slate-900">Our Core Values</h3>
            </div>
          </div>

          {/* Values Grid */}
          <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-6">
            {values.map((val, idx) => (
              <div 
                key={idx} 
                className={`tw-flex tw-gap-4 tw-p-5 tw-bg-white tw-border tw-border-solid tw-border-slate-100/60 tw-rounded-2xl hover:tw-shadow-md tw-transition-shadow ${
                  idx === 4 ? "md:tw-col-span-2" : ""
                }`}
              >
                <div className={`tw-w-10 tw-h-10 tw-rounded-xl ${val.bgColor} ${val.textColor} tw-flex tw-items-center tw-justify-center tw-text-lg tw-flex-shrink-0`}>
                  {val.emoji}
                </div>
                <div>
                  <h4 className="tw-text-sm tw-font-bold tw-text-slate-800 tw-mb-1">
                    {val.title}
                  </h4>
                  <p className="tw-text-xs tw-text-slate-500 tw-leading-relaxed tw-m-0">
                    {val.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>

        </div>

      </div>
    </section>
  );
};

export default Services;
